/**
 * Created by Huy Nguyen on 11/02/17.
 */

export default class QuickMessage {
  templateId: string;
  userId: string;
  message: string;
  subject: string;
  constructor() {
    this.templateId = '';
    this.userId = '';
    this.message = '';
    this.subject = '';
  }

  static mappingObject(_quickMessage: any): QuickMessage {
    // let quickMessage = Object.assign(new QuickMessage(), _quickMessage);
    const quickMessage = new QuickMessage();
    quickMessage.templateId = _quickMessage.ID;
    quickMessage.userId = _quickMessage.UserID;
    quickMessage.message = _quickMessage.Message;
    quickMessage.subject = _quickMessage.Subject;
    return quickMessage;
  }

  static revertMappingObject(_quickMessage: QuickMessage): any {
    const quickMessage: any = {};
    quickMessage.Id = _quickMessage.templateId;
    quickMessage.UserID = _quickMessage.userId;
    quickMessage.Message = _quickMessage.message;
    quickMessage.Subject = _quickMessage.subject;
    return quickMessage;
  }

  static mappingObjects(_quickMessages: any[]): QuickMessage[] {
    const quickMessages: QuickMessage[] = [];
    _quickMessages.forEach(_quickMessage => {
      const quickMessage = QuickMessage.mappingObject(_quickMessage);
      quickMessages.push(quickMessage);
    });
    return quickMessages;
  }
}
